import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.$images = this.$('image');
        this.$links = this.$('link');

        this.events = {
            click: {
                link: 'linkClick'
            },
            mouseenter: {
                link: 'enter'
            },
            mouseleave: {
                link: 'leave'
            }
        }
    }

    init() {

    }

    linkClick(e) {
        e.currentTarget.classList.add('is-clicked');
    }

    enter(e) {

        let $el = e.currentTarget;
        let target = $el.getAttribute('data-target');

        this.$images.forEach($imageGroup => {
            
            if($imageGroup.getAttribute('data-slug') == target) {
                if($imageGroup.callback !== undefined) {
                    $imageGroup.callback.kill();
                }
                $imageGroup.classList.add('is-active');
                $imageGroup.classList.remove('is-leaving');
            }
        });
    }

    leave(e) {
        
        let $el = e.currentTarget;
        let target = $el.getAttribute('data-target');

        this.$images.forEach($imageGroup => {
            if($imageGroup.getAttribute('data-slug') == target) {
                $imageGroup.classList.add('is-leaving');

                $imageGroup.callback = gsap.delayedCall(0.98, () => {
                    $imageGroup.classList.remove('is-leaving');
                    $imageGroup.classList.remove('is-active');
                });
            }
        });
    }

    reset() {

        this.$links.forEach($link => {
            if($link.classList.contains('is-clicked')) {
                $link.classList.remove('is-clicked');
            }
        });
    }
}
